import React, { FC } from 'react';
import { useSelector } from 'react-redux';

import { selectSuburbanRkBackground, selectSuburbanRkTitle } from '../../../selectors/countryside';
import { FiltersBackgroundAdBannerContainer } from '../../../containers/FiltersBackgroundAdBannerContainer';
import defaultBackground from './assets/background.png';

import styles from './Header.css';

export const CountrysideHeader: FC<React.PropsWithChildren> = ({ children }) => {
  const suburbanRkTitle = useSelector(selectSuburbanRkTitle);
  const suburbanRkBackground = useSelector(selectSuburbanRkBackground);

  // Дефолтный фон шапки: кастомная картинка загородного РК либо статичный дефолт.
  // Рекламу на всю область рисует микрофронтенд поверх (CountrysideBrandBannerLayer).
  const backgroundImg = suburbanRkBackground || defaultBackground;

  return (
    <div className={styles['header']} style={{ backgroundImage: `url(${backgroundImg})` }} data-name="HeaderBlock">
      <div className={styles['banner-layer']}>
        <FiltersBackgroundAdBannerContainer />
      </div>
      <div className={styles['content']}>
        <div className={styles['inner']}>
          <div className={styles['title']}>{suburbanRkTitle || 'Дома, дачи и участки'}</div>
          {children}
        </div>
        {!suburbanRkTitle && <div className={styles['overlay']} />}
      </div>
    </div>
  );
};
